import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Search(): React.ReactElement {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.88881 4.04818C11.6935 5.85286 11.6935 8.77881 9.88881 10.5835C8.08414 12.3882 5.15818 12.3882 3.35351 10.5835C1.54883 8.77881 1.54883 5.85286 3.35351 4.04818C5.15818 2.2435 8.08414 2.2435 9.88881 4.04818ZM11.6772 11.5914C13.8821 8.98999 13.7573 5.08827 11.303 2.63397C8.7173 0.0482422 4.52502 0.0482424 1.93929 2.63397C-0.646432 5.21969 -0.646431 9.41198 1.93929 11.9977C4.17329 14.2317 7.6065 14.5356 10.1667 12.9094L12.9646 15.7071C13.3552 16.0976 13.9883 16.0976 14.3788 15.7071C14.7694 15.3166 14.7693 14.6834 14.3788 14.2929L11.6772 11.5914Z" />
    </svg>
  );
}
